module.exports = {"pi":{"clientId":"SDXgs4VjABgmXXA0iLjRyFeMqnYyVwHU"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/qa.config.json
// module id = 832
// module chunks = 0